// https://stackoverflow.com/a/48521127/4204919
import {PIXI} from '@colonist/pixi'

export class RoundedBgView extends PIXI.Graphics {
    private readonly texture: PIXI.Texture
    readonly radius: number

    constructor(w: number, h: number, container: PIXI.Container, texture: PIXI.Texture, radius: number = 5) {
        super()
        this.texture = texture
        this.radius = radius
        const matrix = new PIXI.Matrix()
        matrix.scale(w / texture.width, h / texture.height)

        this.beginTextureFill({
            texture: texture,
            color: 0xffffff,
            alpha: 1,
            matrix: matrix,
        })
        this.drawRoundedRect(0, 0, w, h, this.radius)
        this.endFill()
        container.addChildAt(this, 0)
    }

    isSameBg(texture: PIXI.Texture): boolean {
        return texture == this.texture
    }
}
